import BusinessPage from './Business';

export { BusinessPage };
export default BusinessPage;
